<template>
    <b-form ref="form" :save-url="addUrl" @success="formSuccess" v-slot="{model, loading}"
            :initial-data="initialData" :save-params="{course, location}">
        <div class="row">
            <div class="col-12">
                <validated-input label="Name" v-model="model.name"
                                 :rules="{required: true, max:50}" :disabled="loading"/>
            </div>
            <div class="col-12">
                <validated-input label="Designation" v-model="model.designation"
                                 :rules="{required: false}" :disabled="loading"/>
            </div>
            <div class="col-12">
                <validated-text-area label="Description" v-model="model.description"
                                     :rules="{required: true, max:1000}" :disabled="loading"/>
            </div>
            <div class="col-12">
                <btn class="trn" text="Update" loading-text="Updating..." size="sm" :disabled="loading"
                     :loading="loading"/>
            </div>
        </div>
    </b-form>
</template>

<script>
import urls from '../../../../data/urls';

export default {
    name: 'EditCourseFaculty',

    props: {
        checkIfPublished: { type: Boolean, default: false },
        initialData: { type: Object },
        location: { type: String },
        course: { type: String }
    },

    data () {
        return {
            locationOption: urls.admin.trainingCenter.vueSelect,
            addUrl: urls.admin.course.detailsUrl.faculty.addEdit
        };
    },

    methods: {
        clearFile (file) {
            this.initialData.banner_image = '';
        },
        viewFile (file) {
            window.open(file);
        },
        formSuccess () {
            this.$notify('Successfully Updated Item..!', 'Success',
                {
                    type: 'success'
                }
            );
            this.$emit('success');
        }
    }
};
</script>

<style scoped>

</style>
